import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  allFaqData:any;

  constructor(private util: UtilService) { }
  ngOnInit(): void {
    this.getFaqDetails();
  }

  showFaq(id: string, evt: any) {
    $(evt.target).toggleClass('selected').parent().siblings().children('.acc-head').removeClass('selected');
    $('#' + id).slideToggle(300).parent().siblings().children('.acc-content').slideUp(300);
  }

  getFaqDetails(){
    this.util.handleRequests('get',this.util.getUrl('constants_commenents_all',['FAQ'])).then(res=>{
      this.allFaqData = res.content;
    })
  }

  goTohome() {
    this.util.route('home');
  }

}
